// removed by extract-text-webpack-plugin
module.exports = {"planos":"X15aF","component":"_2FgZY","planosComparar":"Q8uMT","escolha":"_3nFQc","planosSelecionados":"_1edOF","itemSelectedPlans":"FkahO","delete":"CFxvJ","mini":"_1_8Po","notSelected":"mzGpy","desktop":"IE8W_","mobile":"_1R4ZE","btnCompare":"_37RdM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/search/comparison_bar/styles.module.css
// module id = 229
// module chunks = 0